import React from 'react';
import {
  Typography,
  Box,
  Grid,
  Button,
  useTheme,
} from '@mui/material';
import { PageLayout } from '../../components/footer/PageLayout';
import { ContentSection } from '../../components/footer/ContentSection';
import { CTASection } from '../../components/footer/CTASection';

export const PressPage: React.FC = () => {
  const theme = useTheme();

  const pressReleases = [
    {
      title: "Careva Raises $50M Series B to Expand Healthcare Access",
      date: "March 15, 2024",
      summary: "Funding will be used to expand into new markets and enhance platform capabilities.",
    },
    {
      title: "Careva Partners with Major Health Systems",
      date: "February 20, 2024",
      summary: "New partnerships will improve care coordination and patient outcomes.",
    },
    {
      title: "Careva Launches Virtual Care Platform",
      date: "January 10, 2024",
      summary: "New virtual care capabilities make healthcare more accessible than ever.",
    },
  ];

  const mediaCoverage = [
    {
      outlet: "Healthcare Innovation",
      title: "How Careva is Revolutionizing Home Healthcare",
      date: "March 1, 2024",
    },
    {
      outlet: "TechCrunch",
      title: "Careva's Platform Connects Patients with Quality Caregivers",
      date: "February 15, 2024",
    },
    {
      outlet: "Modern Healthcare",
      title: "The Future of Healthcare Delivery is Here",
      date: "January 25, 2024",
    },
  ];

  return (
    <PageLayout
      title="Press & Media"
      subtitle="Stay updated with the latest news, press releases, and media coverage about Careva."
      breadcrumbs={[
        { label: "Company", href: "/company" },
        { label: "Press" },
      ]}
    >
      {/* Press Releases */}
      <ContentSection
        title="Press Releases"
        subtitle="Latest news and announcements from Careva."
        backgroundColor={theme.palette.grey[50]}
      >
        <Grid container spacing={3}>
          {pressReleases.map((release, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Box
                sx={{
                  p: 3,
                  border: `1px solid ${theme.palette.grey[300]}`,
                  borderRadius: 2,
                  backgroundColor: 'white',
                  height: '100%',
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 'bold',
                    mb: 1,
                    color: theme.palette.primary.main,
                  }}
                >
                  {release.title}
                </Typography>
                <Typography variant="body2" sx={{ mb: 2, color: theme.palette.text.secondary }}>
                  {release.date}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    color: theme.palette.text.secondary,
                    lineHeight: 1.6,
                    mb: 2,
                  }}
                >
                  {release.summary}
                </Typography>
                <Button variant="outlined" size="small">
                  Read More
                </Button>
              </Box>
            </Grid>
          ))}
        </Grid>
      </ContentSection>

      {/* Media Coverage */}
      <ContentSection
        title="Media Coverage"
        subtitle="What the media is saying about Careva."
      >
        <Grid container spacing={3}>
          {mediaCoverage.map((coverage, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Box
                sx={{
                  p: 3,
                  border: `1px solid ${theme.palette.grey[300]}`,
                  borderRadius: 2,
                  backgroundColor: 'white',
                  height: '100%',
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 'bold',
                    mb: 1,
                    color: theme.palette.primary.main,
                  }}
                >
                  {coverage.title}
                </Typography>
                <Typography variant="body2" sx={{ mb: 1, color: theme.palette.text.secondary }}>
                  {coverage.outlet}
                </Typography>
                <Typography variant="body2" sx={{ mb: 2, color: theme.palette.text.secondary }}>
                  {coverage.date}
                </Typography>
                <Button variant="outlined" size="small">
                  Read Article
                </Button>
              </Box>
            </Grid>
          ))}
        </Grid>
      </ContentSection>

      {/* CTA Section */}
      <CTASection
        title="Media Inquiries"
        subtitle="For media inquiries, please contact our press team."
        primaryButton={{
          text: "Contact Press Team",
          href: "/contact",
        }}
        secondaryButton={{
          text: "Download Press Kit",
          href: "/press-kit",
          variant: "outlined",
        }}
      />
    </PageLayout>
  );
};
